import type { ThemeOptions } from "@mui/material";

const TOOLTIP_ZINDEX = 100000;

const zIndex: ThemeOptions["zIndex"] = {
  // Needed to have the selected button always on top. Otherwise, it's border may be hidden behind the button that's not selected.
  selectedToggleButton: 2,
  popper: 3,
  nodeLabel: 1,
  tooltip: TOOLTIP_ZINDEX,
  newDirtyRowsModal: TOOLTIP_ZINDEX + 1,
  toast: 10000000,
};

declare module "@mui/material/styles" {
  interface ZIndex {
    selectedToggleButton: number;
    tooltip: number;
    popper: number;
    nodeLabel: number;
    toast: number;
    newDirtyRowsModal: number;
  }
}

export default zIndex;
